import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  auth_token: string;
}

const initialState: AuthState = {
  auth_token: "",
};

export const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    setAuthToken: (state, action: PayloadAction<string>) => {
      state.auth_token = action.payload;
    },
    ClearAuth: (state) => {
      state.auth_token = "";
    },
  },
});

// Action creators are generated for each case reducer function
export const { setAuthToken, ClearAuth } = authSlice.actions;

export default authSlice.reducer;
